import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import { debounce, get } from 'lodash';
import { API_HOST } from '../../consts';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { toast } from 'react-toastify';
import TableRelatorios from '../../components/Table/TableRelatorios';
import { GeneralStudentStyleButton } from '../avalia/style';
import { Container, Grid, CircularProgress } from '@material-ui/core';
import bannerRelatorios from '../../assets/images/plurall_images/banner.png';
import Swal from 'sweetalert2';
import ReportGraphEssay from './ReportGraphEssay';
import StackedBarChart from '../avalia/StackedBarChart';
import BasicBarChart from './BasicBarChart';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import FiltersPageRelatorio from '../avalia/FiltersPageRelatorio';
import Loading from '../../components/Loading';
import ReportSkillLevelPage from './ReportSkillLevelPage';
import ClassReportPage from './ClassReportPage';
import ComparativeClasses from './ComparativeClasses';

const ReportProficiencyScalePage = ({ className }) => {
  const [schoolLevel, setSchoolLevel] = useState(undefined);
  const [downloading, setDownloading] = useState(false);
  const [fileKey, setFileKey] = useState();
  const [statusCSV, setStatusCSV] = useState();
  const [lastGeneratedDate, setLastGeneratedDate] = useState();
  const [graphRedacaoBar, setGraphRedacaoBar] = useState([]);
  const [graphRedacaoCompetencia, setGraphRedacaoCompetencia] = useState([]);
  const [basicBarChart, setBasicBarChart] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [graphRedacaoCompetenciaPie, setGraphRedacaoCompetenciaPie] = useState([]);

  const { filtrosRelatorios, setStateFilters } = useContext(FilterRelatorioContext)
  const theme = useContext(ThemeContext);

  function sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }

  useEffect(() => {
    if (filtrosRelatorios.isFormSubmit === true) {
      buttonRelatorio();
      setStateFilters({ isFormSubmit: false })
    }
  }, [filtrosRelatorios.isFormSubmit])

  const fetchStatusMicrodados = async (id) => {
    await sleep(5e3);

    const params = { id: id }
    await Axios.get(
      `${API_HOST}/avalia/microdados/get_microdados_status`, { params }
    )
      .then((res) => {
        if (res.data.file_key) {

          const link = document.createElement('a');
          link.href = res.data.file_key;

          link.download = 'microdados.csv';

          link.click();

          setDownloading(false)
          fetchLastMicrodados()
        } else {
          fetchStatusMicrodados(id)
          setDownloading(true)
        }
      })
      .catch((err) =>
        toast.error(err)
      );
  }

  const handleDownloadCSV = () => {
    const dataISO = lastGeneratedDate;
    let formatBr = 'Arquivo não gerado'
    if (dataISO !== '') {
      const data = new Date(dataISO);
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      };

      formatBr = data.toLocaleDateString("pt-BR", options);
    }
    if (!downloading) {
      Swal.fire({
        title: `Data da última geração: ${formatBr}`,
        showCancelButton: dataISO ? true : false,
        confirmButtonText: dataISO ? 'Gerar Novamente' : 'Gerar',
        cancelButtonText: 'Baixar Anterior',
        showConfirmButton: statusCSV === 4 ? true : false
      }).then((result) => {
        if (result.isConfirmed) {
          get_microdados_csv();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          const link = document.createElement('a');
          link.href = fileKey;
          link.download = 'microdados.csv';
          link.click();
        }
      });
    }
  };

  const fetchLastMicrodados = () => {
    const params = {
      cd_escola: filtrosRelatorios.currentEscola,
      periodo_ano_id: filtrosRelatorios.periodoAno
    }
    Axios.get(`${API_HOST}/avalia/microdados/get_last_generated`, { params })
      .then((response) => {
        if (response.data && response.data.res) {
          setLastGeneratedDate(response.data.res.criado_em)
          setFileKey(response.data.res.file_key)
          setStatusCSV(response.data.status)
        }
      })
      .catch((err) => console.error(err));
  };

  const get_microdados_csv = debounce(() => {
    setDownloading(true)
    const payload = {
      cd_escola: filtrosRelatorios.currentEscola,
      periodo_ano_id: filtrosRelatorios.periodoAno
    }
    Axios.post(
      `${API_HOST}/avalia/microdados/get_microdados_csv`, { payload }
    )
      .then((res) => {
        fetchStatusMicrodados(res.data)
      })
      .catch((err) =>
        toast.error(err)
      );
  }, 1000)

  const fetchSchoolLevel = () => {
    setIsLoading(true)
    const params = {
      cd_escola: filtrosRelatorios.currentEscola,
      prova_a_cd_disciplina: filtrosRelatorios.DisciplinaID,
      periodo_ano_id: filtrosRelatorios.periodoAno,
    }

    Axios.get(
      `${API_HOST}/avalia/distribuicao_percentual`, { params }
    )
      .then((res) => {
        if (res.data.results.length == 0) {
          setIsLoading(false)
          return toast.error('Não existem dados para a consulta realizada');
        } else {
          setStateFilters({ fecth: true })
          setSchoolLevel(res.data.results);
          setIsLoading(false)
        }
      })
      .catch((err) => {
        setIsLoading(false)
        toast.error('Não existem dados para a consulta realizada')
      })
  };

  const fetchGraphEssayBar = async (etapaEscola) => {
    try {
      const params = {
        tipo: 'redacao-escola-bar',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        nr_etapa: etapaEscola

      };
      const res = await Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, { params })
      if (res.data.data.length !== 0) {
        setGraphRedacaoBar((prev) => [...prev, res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchGraphEssayCompetenciaBar = async (etapaEscola) => {
    try {
      const params = {
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        nr_etapa: etapaEscola
      };
      const res = await Axios.get(`${API_HOST}/avalia/estudante/get_stacked_area_graph`, { params })
      if (res.data.data.length !== 0) {
        setGraphRedacaoCompetencia((prev) => [...prev, res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchGraphEssayCompetenciaPie = async (etapaEscola) => {
    try {
      const params = {
        tipo: 'redacao-escola-pie',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        nr_etapa: etapaEscola
      };
      const res = await Axios.get(`${API_HOST}/avalia/estudante/get_stacked_area_graph`, { params })
      if (res.data.series.length == 0) {
        return
      }
      else {
        setGraphRedacaoCompetenciaPie((prev) => [...prev, res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchBasicBarChart = async () => {
    try {
      const params = {
        tipo: 'dre-comparativo-media-dn-dr-escola',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        periodoAnoId: filtrosRelatorios.periodoAno,
      };
      const res = await Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      setBasicBarChart(res.data);
    } catch (error) {
      console.error(error);
    }
  }

  const buttonRelatorio = () => {
    setStateFilters({ fecthComparativo: false, fecthRelatorioGeral: false, fecthRelatorioHabilidade: false, fecth: false });
    if (filtrosRelatorios.DisciplinaID == 8) {
      for (let i = 1; i <= 13; i++) {
        fetchGraphEssayBar(i);
        fetchGraphEssayCompetenciaBar(i);
        fetchGraphEssayCompetenciaPie(i);
        fetchGraphEssayCompetenciaPie(i);
      }
      fetchBasicBarChart();
    }
    fetchSchoolLevel();
    if (filtrosRelatorios.DisciplinaID != 8) {
      fetchLastMicrodados();
    }
  }

  const titulo = [
    'Linguagens, Códigos e suas Tecnologias',
    'Matemática e suas Tecnologias'
  ];

  const redirectToSchoolLink = () => {

    const linkSchool = schoolLevel ? schoolLevel[0]['link_school'] : ''

    if (linkSchool) {
      window.open(linkSchool, '_blank');
    }
  }

  const redeOrdn = 'REDE, DRE';

  return (
    <div className={className}>
      <div style={{ marginTop: '3rem', background: '#fff' }}>
        <div className="container mb-4 pb-4">
          <div className="row">
            <div className="col-12">
              <div
                className="card"
                style={{
                  backgroundColor: '#f7f7f7',
                  borderRadius: '10px'
                }}
              >
                <div
                  className="card-header"
                  style={{
                    marginBottom: '-0.7rem',
                    backgroundColor: '#f7f7f7',
                    borderRadius: '10px'
                  }}
                >
                  <h1
                    style={{
                      fontFamily: 'Quicksand',
                      fontSize: '24px',
                      color: '#292929',
                      fontWeight: 'bold'
                    }}
                  >
                    Relatório da Escola
                  </h1>
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#292929',
                      fontWeight: 500,
                      fontFamily: 'Quicksand'
                    }}
                  >
                    Distribuição Percentual dos Estudantes nos Níveis da Escala
                    de Proficiência
                  </span>
                  <hr
                    style={{
                      background: '#bebebe',
                      width: '100%',
                      height: '1px',
                      borderRadius: '1px'
                    }}
                  />
                </div>
                <div
                  className="card-body"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  <FiltersPageRelatorio buttonRelatorio={buttonRelatorio} />

                  {isLoading && (
                    <>
                      <Loading/>
                    </>
                  )}

                  {filtrosRelatorios.fecth && (
                    <>
                      {filtrosRelatorios.DisciplinaID == 8 ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          {
                            basicBarChart && (
                              <div className="mt-2" style={{ width: '100%' }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: `${theme.primary}`,
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                  }}
                                >
                                  <div
                                    className="basic__info"
                                    style={{
                                      padding: '0.3rem',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: 'white',
                                        marginTop: '0.5rem',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        textTransform: 'uppercase',
                                        marginRight: "60px",
                                      }}
                                    >
                                      Gráfico comparativo REDE, DRE e Escola
                                    </label>
                                  </div>
                                </div>
                                <BasicBarChart
                                  data={basicBarChart}
                                  title={''}
                                />
                              </div>
                            )
                          }

                          {
                            graphRedacaoCompetencia && graphRedacaoCompetencia.map(item => (
                              <div className="mt-2" style={{ width: '100%' }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: `${theme.primary}`,
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                  }}
                                >
                                  <div
                                    className="basic__info"
                                    style={{
                                      padding: '0.3rem',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: 'white',
                                        marginTop: '0.5rem',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        textTransform: 'uppercase',
                                        marginRight: "60px",
                                      }}
                                    >
                                      {item.data.etapa.name} - Gráfico Proficiência por Competência
                                    </label>
                                  </div>
                                </div>
                                <StackedBarChart
                                  dados={item.data}
                                  tituloCompleto={''}
                                  media={true}
                                />
                                <StackedBarChart
                                  dados={item.data}
                                  tituloCompleto={''}
                                />
                              </div>
                            ))
                          }
                          {/* NAO APAGAR! ESSE TRECHO DEVE SER MANTIDO PARA FACILITAR ALTERACOES FUTURAS PELO SESI. */}
                          {/* {
                            graphRedacaoCompetenciaPie && graphRedacaoCompetenciaPie.map(item => (
                              <div className="mt-2" style={{ width: '100%' }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: `${theme.primary}`,
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                  }}
                                >
                                  <div
                                    className="basic__info"
                                    style={{
                                      padding: '0.3rem',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: 'white',
                                        marginTop: '0.5rem',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        textTransform: 'uppercase',
                                        marginRight: "60px",
                                      }}
                                    >
                                      Gráfico Nota por Competência
                                    </label>
                                  </div>
                                </div>
                                <CompetenciasPieCharts
                                  data={item}
                                />
                              </div>
                            ))
                          } */}

                          {
                            graphRedacaoBar && graphRedacaoBar.map(item => (
                              <div className="mt-2" style={{ width: '100%' }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: `${theme.primary}`,
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                  }}
                                >
                                  <div
                                    className="basic__info"
                                    style={{
                                      padding: '0.3rem',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: 'white',
                                        marginTop: '0.5rem',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        textTransform: 'uppercase',
                                        marginRight: "60px",
                                      }}
                                    >
                                      {item.data.etapa.name} - Gráfico Estudantes por Proficiência
                                    </label>
                                  </div>
                                </div>

                                <ReportGraphEssay
                                  data={item.data}
                                  title={''}
                                  type={'column'}
                                />
                              </div>
                            ))
                          }

                        </div>
                      ) : (
                        <>
                          <div
                            className="school__material"
                            style={{ color: `${theme.primary}` }}
                          >
                            <span>
                              {
                                titulo[
                                schoolLevel
                                  ? get(schoolLevel[0], 'prova_a_cd_disciplina', '') -
                                  1
                                  : ''
                                ]
                              }
                            </span>
                          </div>
                          {schoolLevel &&
                            schoolLevel.map((dados) => (
                              <div className="mt-2" style={{ width: '100%' }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: `${theme.primary}`,
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px',
                                  }}
                                >
                                  <div
                                    className="basic__info"
                                    style={{
                                      padding: '0.3rem',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: 'white',
                                        marginTop: '0.5rem',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        textTransform: 'uppercase',
                                        marginRight: "60px",
                                      }}
                                    >
                                      {' '}
                                      {dados.prova_a_prova_ds}{' '}
                                    </label>
                                  </div>
                                </div>

                                <TableRelatorios
                                  data={dados.dados_etapa_escolar}
                                  status={dados.status}
                                />
                                <GeneralStudentStyleButton>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      marginBottom: "1rem",
                                      marginTop: "1rem"
                                    }}
                                  >
                                    <button
                                      className='button-primary'
                                      style={{
                                        border: 'none',
                                        fontSize: '1rem',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        borderRadius: '20px',
                                        boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                        padding: '4px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                      }}
                                      onClick={() => {
                                        setStateFilters({
                                          fecthComparativo: true,
                                          fecthRelatorioGeral: false,
                                          fecthRelatorioHabilidade: false,
                                          fecth: false,
                                          dadosEtapaEscolar: dados.etapa_escolar
                                        })
                                      }}
                                    >
                                      Comparativo entre turmas
                                    </button>
                                    <button
                                      className="button-secondary"
                                      style={{
                                        border: 'none',
                                        fontSize: '1rem',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        borderRadius: '20px',
                                        boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                        padding: '4px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginLeft: "1rem"
                                      }}
                                      onClick={() => {
                                        setStateFilters({
                                          fecthRelatorioGeral: true,
                                          fecthRelatorioHabilidade: false,
                                          fecth: false,
                                          dadosEtapaEscolar: dados.etapa_escolar
                                        })
                                      }}
                                    >
                                      Relatório de Proficiência
                                    </button>
                                    <button
                                      className='button-primary'
                                      style={{
                                        border: 'none',
                                        fontSize: '1rem',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        borderRadius: '20px',
                                        boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                        padding: '4px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginLeft: "1rem"
                                      }}
                                      onClick={() => {
                                        setStateFilters({
                                          fecthRelatorioHabilidade: true,
                                          fecth: false,
                                          dadosEtapaEscolar: dados.etapa_escolar
                                        })
                                      }}
                                    >
                                      Relatório de Habilidades
                                    </button>
                                  </div>
                                </GeneralStudentStyleButton>
                              </div>
                            ))}
                        </>
                      )}
                    </>
                  )}
                  {filtrosRelatorios.fecthRelatorioHabilidade && (
                    <ReportSkillLevelPage />
                  )}
                  {filtrosRelatorios.fecthRelatorioGeral && (
                    <ClassReportPage />
                  )}
                  {filtrosRelatorios.fecthComparativo && (
                    <ComparativeClasses />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
};

export default withRouter(ReportProficiencyScalePage);
